<script>
	import { Route, Router } from "svelte-routing";
	import FilterMode from "./Manage/FilterMode.svelte";
	import CompareMode from "./Manage/CompareMode/CompareMode.svelte";
	import VehicleIssues from "./Manage/IssueTable/VehicleIssues/MainIssue.svelte";
	import NotFound from "../../views/NotFound.svelte";
	import { userRole } from "../../store/store";

	import VehicleCompareDetail from "./Manage/IssueTable/VehicleIssues/VehicleCompareIssue.svelte";
	import IssuePendingReview2 from "./Manage/IssueTable/PendingReview2/MainIssue.svelte";
	import ApprovedIssues2 from "./Manage/IssueTable/ApprovedIssues2/MainIssue.svelte";
	import RejectedIssues2 from "./Manage/IssueTable/RejectedIssues2/MainIssue.svelte";
</script>

<Router url="/">
	{#if $userRole.includes(8)}
		<Route path="/vehicle-issues" component={VehicleIssues} />

		<Route path="/vehicle-issues/details/:vehicle_id" let:params>
			<VehicleCompareDetail vehicleId={params.vehicle_id} />
		</Route>

		<Route path="/pending-issues" component={IssuePendingReview2} />

		<Route path="/cmm-approved-issues" component={ApprovedIssues2} />

		<Route path="/cmm-rejected-issues" component={RejectedIssues2} />

		<Route path="/filter-mode" component={FilterMode} />

		<Route path="/compare-mode" component={CompareMode} />
	{:else}
		<Route path="/filter-mode" component={NotFound} />
	{/if}
</Router>
